module.exports = __webpack_public_path__ + "static/media/42.3d6a146a.jpg";